module.exports = (__webpack_require__(15))(18);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js from dll-reference vendor_library
// module id = 189
// module chunks = 0